/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLeasingContractDto } from '../../models/backend-leasing-contract-dto';
import { BackendLeasingContractRequestDto } from '../../models/backend-leasing-contract-request-dto';

export interface FinancingSourcesLeasingsCreate$XWwwFormUrlencoded$Params {
  body: BackendLeasingContractRequestDto;
}

export function financingSourcesLeasingsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesLeasingsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesLeasingsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLeasingContractDto>;
    }),
  );
}

financingSourcesLeasingsCreate$XWwwFormUrlencoded.PATH = '/api/financing_sources/leasings/';
